import { render, staticRenderFns } from "./PointsPackageDialog.vue?vue&type=template&id=459558dc&scoped=true"
import script from "./PointsPackageDialog.vue?vue&type=script&lang=js"
export * from "./PointsPackageDialog.vue?vue&type=script&lang=js"
import style0 from "./PointsPackageDialog.vue?vue&type=style&index=0&id=459558dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459558dc",
  null
  
)

export default component.exports